import React from "react";
import { useSelector } from "react-redux";
import LoginScreen from "../../components/LoginScreen/LoginScreen";
import AccessDenied from "../../components/common/AccessDenied";

const InvestorRoute = ({ auth: { isAuthenticated }, children, allowedRoles = null }) => {
  const userState = useSelector((store) => store.auth);
  const USER_DETAILS = userState?.user?.userDetails;

  if (typeof isAuthenticated === "undefined" || !userState?.user) {
    return <LoginScreen />;
  }

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  if (!allowedRoles?.includes(USER_DETAILS?.user_type.toLowerCase())) {
    return <AccessDenied />;
  }

  return children;
};

export default InvestorRoute;
